// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationButtons_pagination__FHeGy"};